import { useEffect, useState } from "react";
import Logo from "./Logo";
import { scrollToId } from "../lib/scroll";

export default function Navbar() {
    const [scrolled, setScrolled] = useState(false);

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 40);
        onScroll();
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    const links = [
        { id: "hero", label: "SOUND", testid: "nexora-nav-explore-link" },
        { id: "technology", label: "TECHNOLOGY", testid: "nexora-nav-specs-link" },
        { id: "reserve", label: "RESERVE", testid: "nexora-nav-reserve-link" },
    ];

    return (
        <header
            data-testid="nexora-nav-header"
            className={`fixed inset-x-0 top-0 z-50 transition-all duration-500 ${
                scrolled
                    ? "border-b border-white/5 bg-ink/70 backdrop-blur-xl"
                    : "border-b border-transparent bg-transparent"
            }`}
        >
            <nav className="mx-auto flex h-16 max-w-7xl items-center justify-between px-6 md:h-20 md:px-10">
                <button
                    data-testid="nexora-nav-logo"
                    onClick={() => scrollToId("hero")}
                    aria-label="NEXORA home"
                >
                    <Logo markClass="h-8 w-8" wordClass="text-base md:text-lg" />
                </button>

                <div className="hidden items-center gap-10 font-mono text-[11px] tracking-[0.25em] text-white/50 md:flex">
                    {links.map((l) => (
                        <button
                            key={l.id}
                            data-testid={l.testid}
                            onClick={() => scrollToId(l.id)}
                            className="transition-colors duration-300 hover:text-volt"
                        >
                            {l.label}
                        </button>
                    ))}
                </div>

                <button
                    data-testid="nexora-nav-preorder-btn"
                    onClick={() => scrollToId("reserve")}
                    className="rounded-full border border-volt/40 bg-volt/10 px-5 py-2 text-[11px] font-semibold tracking-[0.2em] text-volt transition-all duration-300 hover:bg-volt hover:text-ink hover:shadow-[0_0_24px_rgba(0,240,255,0.4)]"
                >
                    RESERVE
                </button>
            </nav>
        </header>
    );
}
